import * as i18n from '../ducks/i18n';
import * as builder from '../ducks/builder';

/**
 * Reexports
 */
export * from '../utils/utils';
export * from '../LayoutContext';
export * from '../LayoutConfig';
export { default as LayoutConfig } from '../LayoutConfig';
export { default as mockAxios } from '../__mocks__/mockAxios';
export { default as LayoutInitializer } from '../LayoutInitializer';
// export { I18nProvider } from "../../_metronic/i18n/I18nProvider";
export { default as I18nProvider } from '../../_metronic/i18n/I18nProvider';
export { default as ThemeProvider } from '../ThemeProvider';

/**
 * Ducks
 */

export const metronic = { i18n, builder };
